import { Hero } from '../components/home/Hero';
import { HowItWorksSection } from '../components/home/HowItWorksSection';
import { WhoItsForSection } from '../components/home/WhoItsForSection';
import { DataViewsSection } from '../components/home/DataViewsSection';
import { MethodologySection } from '../components/home/MethodologySection';
import { CewSiteFooter } from '../components/layout/CewSiteFooter';
import { HomeRail } from '../components/home/HomeRail';
import { SectionNav } from '../components/layout/SectionNav';

/**
 * Marketing landing page. Order matches `_archive/home.html`:
 *   1. Hero (full-bleed navy with illustration overlay -- CR-027)
 *   2. SectionNav (sticky 6-tab strip — pins to top:var(--h-topbar) on scroll)
 *   3. Two-column content body — 3/12 sticky rail + 9/12 main content
 *   4. CewSiteFooter (CR-030 -- replicated cew.georgetown.edu global
 *      footer + funder credit strip; shared across Home/Rankings/
 *      Detail/Compare/Providers)
 */
export default function HomePage() {
  return (
    <>
      <Hero />
      <SectionNav />
      {/* Two-column editorial body — full viewport width, no max-w cap.
          Mirrors prototype's `.content-body { display: grid; grid-template-
          columns: repeat(12, 1fr); }` with no outer max-width. The rail
          claims 3/12 (cols 1-3), main content claims 9/12 (cols 4-12). */}
      <div className="grid grid-cols-1 lg:grid-cols-12">
        {/* Aside padding mirrors prototype `.content-rail { padding: 56px
            16px 56px 56px }` — 56 left to match the section outer padding,
            tight 16 right so the rail card sits closer to the main column. */}
        <aside className="relative z-20 col-span-3 hidden pt-14 pr-4 pb-14 pl-14 lg:block">
          <HomeRail />
        </aside>
        <div className="col-span-12 lg:col-span-9">
          <HowItWorksSection />
          <DataViewsSection />
          <WhoItsForSection />
          <MethodologySection />
        </div>
      </div>
      <CewSiteFooter />
    </>
  );
}
